<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='950px'>
    <el-form v-loading='formLoading' :model='form' label-width='140px' label-position='right'
             ref='ruleForm'>
      <div-border label='基本信息' class='p20'>
        <el-row :gutter='10'>
          <el-col :span='12'>
            <el-form-item label='委托商：'>
              <span>{{ form.customer |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='委托商作业数量：'>
              <span>{{ form.customerTaskNum |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='结算类型：'>
              <span>{{ form.settlementType |settlementTypeFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='品牌：'>
              <span>{{ form.brand |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='港口/库房名称：'>
              <span>{{ form.name |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='供应商：'>
              <span>{{ form.supplier |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='供应商作业数量：'>
              <span>{{ form.supplierTaskNum |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='作业类型：'>
              <span>{{ form.taskType |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='作业时间：'>
              <span>{{ form.taskTime |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='面积：'>
              <span>{{ form.square |valFormat }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div-border>

      <div-border label='操作记录' class='p20'>
        <el-table
          ref='registerTable'
          row-key='id'
          v-loading='tableLoading'
          :data='form.operateRecords'
          style='width: 100%'
          border
          :header-cell-style='headerCellStyle'
        >
          <el-table-column prop='createTime' label='操作时间' align='center' width='160px' />
          <el-table-column prop='operateType' label='操作类型' align='center' />
          <el-table-column prop='operationName' label='操作人' align='center' />
          <el-table-column prop='remark' label='备注' align='center' />
        </el-table>
      </div-border>
    </el-form>
  </el-dialog>
</template>

<script>
  import divBorder from '@/components/divBorder.vue';
  import { portWarehouseCostDetail } from '@/service/warehouse';

  export default {
    name: 'portWarehouseChargesInfo',
    components: { divBorder },
    data() {
      return {
        dialogTitle: '详情',
        dialogVisible: false,
        defaultForm: {},
        form: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        formLoading: false,
      };
    },
    filters: {
      valFormat(str) {
        if (str) {
          return str;
        } else {
          return '无';
        }
      },
      settlementTypeFormat(str) {
        switch (str) {
          case 0:
            return '库房';
          case 1:
            return '港口';
        }
      },
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      dialogOpen(id) {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.getDetails(id);
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      async getDetails(id) {
        this.formLoading = true;
        const {
          status,
          message,
          data,
        } = await portWarehouseCostDetail(id);
        this.formLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.form = data;
      },
    },
  };
</script>

<style lang='scss' scoped></style>
